import React, { Component } from 'react'

export default function withPropsChecker(WrappedComponent, displayName) {
  return class PropsChecker extends Component {
    componentDidUpdate(nextProps) {
      if (process.env.NODE_ENV === 'development') {
        return
      }
      Object.keys(nextProps)
        .filter((key) => {
          return nextProps[key] !== this.props[key]
        })
        .forEach((key) => {
          console.log(`${displayName} ----> changed property:`, key, 'from', this.props[key], 'to', nextProps[key])
        })
    }
    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}
